module.exports = __webpack_public_path__ + "img/photograph.f995491a.png";